import CmsXPagesContent from "./containers/XPagesContent/containers/XPagesContent/XPagesContent.js";
import { CmsRowPDPContainer } from "./containers/RowComponent/RowPDPContainer/containers/RowComponent/RowPDPContainer/RowPDPContainer.js";
import { CmsRowTab } from "./containers/RowComponent/RowTab/containers/RowComponent/RowTab/RowTab.js";
import { CmsRowVideo } from "./containers/RowComponent/RowVideo/containers/RowComponent/RowVideo/RowVideo.js";
import { CmsRowImage } from "./containers/RowComponent/RowImage/containers/RowComponent/RowImage/RowImage.js";
import { CmsRowColumn } from "./containers/RowComponent/RowColumn/containers/RowComponent/RowColumn/RowColumn.js";
import { CmsRow } from "./containers/RowComponent/Row/containers/RowComponent/Row/Row.js";
import { CmsSeo } from "./containers/Seo/containers/Seo/Seo.js";
import { CmsEmpty } from "./containers/Empty/containers/Empty/Empty.js";
import Whitespace from "./containers/Whitespace/containers/Whitespace/Whitespace.js";
import Breadcrumbs from "./containers/Breadcrumbs/containers/Breadcrumbs/Breadcrumbs.js";
import RowProductListBySku from "./containers/RowComponent/RowProductListBySku/containers/RowComponent/RowProductListBySku/RowProductListBySku.js";
import RowText from "./containers/RowComponent/RowText/containers/RowComponent/RowText/RowText.js";
import CmsRecommendedProducts from "./containers/RecommendedProducts/containers/RecommendedProducts/RecommendedProducts.js";
import GlobalContactForm from "./containers/GlobalContactForm/containers/GlobalContactForm/GlobalContactForm.js";
import GroupedCards from "./containers/GroupedCards/containers/GroupedCards/GroupedCards.js";
import TryInStoreBanner from "./containers/TryInStoreBanner/containers/TryInStoreBanner/TryInStoreBanner.js";
import RecentlyViewedProducts from "./containers/RecentlyViewedProducts/containers/RecentlyViewedProducts/RecentlyViewedProducts.js";
import WidgetTrustedShop from "./containers/WidgetTrustedShop/containers/WidgetTrustedShop/WidgetTrustedShop.js";
import CmsWidget from "./containers/Widget/containers/Widget/Widget.js";
import CmsVideo from "./containers/Video/containers/Video/Video.js";
import CmsAccordion from "./containers/Accordion/containers/Accordion/Accordion.js";
import SpotlightedStores from "./containers/SpotlightedStores/containers/SpotlightedStores/SpotlightedStores.js";
import RichText from "./containers/RichText/containers/RichText/RichText.js";
import Promotion from "./containers/Promotion/containers/Promotion/Promotion.js";
import ProductCatalog from "./containers/ProductCatalog/containers/ProductCatalog/ProductCatalog.js";
import PolicyBar from "./containers/PolicyBar/containers/PolicyBar/PolicyBar.js";
import NotificationBar from "./containers/NotificationBar/containers/NotificationBar/NotificationBar.js";
import Newsletter from "./containers/Newsletter/containers/Newsletter/Newsletter.js";
import CmsIframe from "./containers/Iframe/containers/Iframe/Iframe.js";
import IconList from "./containers/IconList/containers/IconList/IconList.js";
import Heading from "./containers/Heading/containers/Heading/Heading.js";
import Faq from "./containers/Faq/containers/Faq/Faq.js";
import Document from "./containers/Document/containers/Document/Document.js";
import CountdownTimer from "./containers/CountdownTimer/containers/CountdownTimer/CountdownTimer.js";
import CmsCarousel from "./containers/Carousel/containers/Carousel/Carousel.js";
import Button from "./containers/Button/containers/Button/Button.js";
import BrandList from "./containers/BrandList/containers/BrandList/BrandList.js";
import BrandCollection from "./containers/BrandCollection/containers/BrandCollection/BrandCollection.js";
import BlogOverview from "./containers/BlogOverview/containers/BlogOverview/BlogOverview.js";
import BlogCollection from "./containers/BlogCollection/containers/BlogCollection/BlogCollection.js";
import CmsBannerCollection from "./containers/BannerCollection/containers/BannerCollection/BannerCollection.js";
import CmsBanner from "./containers/Banner/containers/Banner/Banner.js";
import Article from "./containers/Article/containers/Article/Article.js";
const defaultComponentDefinitions = {
  Accordion: CmsAccordion,
  Article,
  Banner: CmsBanner,
  "Banner collection": CmsBannerCollection,
  "Blog Collection": BlogCollection,
  "Blog Overview": BlogOverview,
  "Brand collection": BrandCollection,
  "Brand List": BrandList,
  "CTA Button": Button,
  Carousel: CmsCarousel,
  "Countdown timer": CountdownTimer,
  Document,
  FAQ: Faq,
  Heading,
  "Icon-Link List": IconList,
  IFrame: CmsIframe,
  Newsletter,
  "Notification bar": NotificationBar,
  Page: CmsEmpty,
  "Policy bar": PolicyBar,
  "Product catalog v2": ProductCatalog,
  "Promotion Algolia": Promotion,
  Promotion,
  "Rich Text": RichText,
  Seo: CmsSeo,
  "Spotlighted stores": SpotlightedStores,
  Translation: CmsAccordion,
  Video: CmsVideo,
  Widget: CmsWidget,
  "Widget Trusted Shops": WidgetTrustedShop,
  "Recently viewed products": RecentlyViewedProducts,
  TryInStoreBanner,
  "Group Cards": GroupedCards,
  "Global Contact Form": GlobalContactForm,
  RecommendedProducts: CmsRecommendedProducts,
  row: CmsRow,
  "row-1": CmsRow,
  "row-2": CmsRow,
  "row-3": CmsRow,
  "row-4": CmsRow,
  "row-5": CmsRow,
  "row-6": CmsRow,
  "row-7": CmsRow,
  "row-8": CmsRow,
  "row-9": CmsRow,
  "row-10": CmsRow,
  "row-11": CmsRow,
  "row-12": CmsRow,
  "row-13": CmsRow,
  "row-14": CmsRow,
  "row-15": CmsRow,
  "row-16": CmsRow,
  "row-17": CmsRow,
  "row-18": CmsRow,
  "row-19": CmsRow,
  "row-20": CmsRow,
  "column-wrapper-1": CmsRowColumn,
  "column-wrapper-2": CmsRowColumn,
  "column-wrapper-3": CmsRowColumn,
  "column-wrapper-4": CmsRowColumn,
  "Row component : Image": CmsRowImage,
  "Row component : Text": RowText,
  "Row component : Video": CmsRowVideo,
  "Row component : Product list by SKU": RowProductListBySku,
  "row-tabs-container": CmsRowTab,
  "row-pdp-container": CmsRowPDPContainer,
  Content: CmsXPagesContent,
  Breadcrumbs,
  "Whitespace component": Whitespace
};
function extendComponentDefinitions(definitionsToAdd) {
  return {
    ...defaultComponentDefinitions,
    ...definitionsToAdd
  };
}
export {
  defaultComponentDefinitions,
  extendComponentDefinitions
};
//# sourceMappingURL=component-definitions.js.map
